<div class="rs-panel-big rs-bg-c2 clearfix">
  <p class="rs-tit3 rs-padding-bottom1">
    {{
      (isResUser
        ? 'bills.redesign.downloadCard.titleRes'
        : 'bills.redesign.downloadCard.titleSe'
      ) | translate
    }}
  </p>
  <p data-cy="myBillDownloadCardDescription" *ngIf="!isResUser">
    {{ 'bills.redesign.downloadCard.descriptionSe' | translate }}
  </p>

  <ng-container *ngIf="showCsvDownload; else showPdfDownloadOnly">
    <ul class="no-bullet">
      <ng-container *ngTemplateOutlet="downloadLinks"></ng-container>
      @if ( !showCsvMessageInvoiceOlderThan12Months){
      <my-bill-odb-download-csv
        [documentReference]="billDocument.reference"
        [billingAccountNumber]="billingAccount.accountNumber"
        [customerId]="customerId"
        (downloadFileError)="handleDownloadError($event)"
      >
      </my-bill-odb-download-csv>
      }
    </ul>

    <ng-template #csvMsgInvoiceOlderThan12Months>
      <p>
        <span class="rs-font-pxB">{{
          'bills.redesign.downloadCard.documentOlderThan12Months.title'
            | translate
        }}</span>
        <br />
        <span class="rs-txt-details">{{
          'bills.redesign.downloadCard.documentOlderThan12Months.description'
            | translate
        }}</span>
      </p>
    </ng-template>
  </ng-container>
  <ng-template #showPdfDownloadOnly>
    <ul class="no-bullet">
      <ng-container *ngTemplateOutlet="downloadLinks"></ng-container>
    </ul>
  </ng-template>

  <lib-generic-message-box
    [messageType]="messageBoxTypeError"
    id="messageBoxTypeError"
    [showCross]="false"
    [cypressTag]="messageBoxTypeError"
    *ngIf="hasCsvError"
  >
    <ng-container Title *ngIf="messageBoxTitle">{{
      messageBoxTitle
    }}</ng-container>
    <p Content [innerHtml]="messageBoxContent" *ngIf="messageBoxContent"></p>
  </lib-generic-message-box>
</div>

<ng-template #downloadLinks>
  <my-bill-pdf-document
    [buttonZone]="buttonZone"
    [paId]="billingAccount.accountNumber"
    [customerId]="customerId"
    [documentId]="billDocument.reference"
    [documentDate]="billDocument.documentDate"
    [docType]="'pdf'"
    [isLink]="true"
    (downloadFileError)="handleDownloadError($event)"
  ></my-bill-pdf-document>
  @if (showXmlDownload){
  <my-bill-pdf-document
    [buttonZone]="buttonZone"
    [paId]="billingAccount.accountNumber"
    [customerId]="customerId"
    [documentId]="billDocument.reference"
    [documentDate]="billDocument.documentDate"
    [docType]="'xml'"
    [isLink]="true"
    (downloadFileError)="handleDownloadError($event)"
  >
  </my-bill-pdf-document>
  } @if (thirdPartyReference){
  <my-bill-pdf-document
    [buttonZone]="buttonZone"
    [paId]="billingAccount.accountNumber"
    [customerId]="customerId"
    [documentId]="thirdPartyReference"
    [documentDate]="billDocument.documentDate"
    [docType]="'xml'"
    [isLink]="true"
    [showThirdParty]="true"
    (downloadFileError)="handleDownloadError($event)"
  >
  </my-bill-pdf-document>
  }
</ng-template>
